export default __webpack_public_path__ + "8550100c74139b853789872ccc239bda.svg";